import dictionary from './dictionary';
import locale from './locale';

export default dictionary;
export { locale };
